<template>
  <div v-if="isVisibile" class="banner-tg-bot">
    <div class="banner-tg-bot__body">
      <div class="banner-tg-bot__logo"></div>
      <p class="body body_size_L">
        Домашка сама себя не решит. Но наш бот — запросто!
      </p>
      <a
        class="body body_size_L banner-tg-bot__link"
        href="https://t.me/kazatel_su"
        target="_blank"
      >
        Бежать в Телеграм
        <svg-icon iconName="kuiIconArrowRight" size="16px" />
      </a>
    </div>
    <button class="banner-tg-bot__close-btn" @click="$emit('close')">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L3.58579 5L0.292893 8.29289C-0.0976311 8.68342 -0.0976311 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5 6.41421L8.29289 9.70711C8.68342 10.0976 9.31658 10.0976 9.70711 9.70711C10.0976 9.31658 10.0976 8.68342 9.70711 8.29289L6.41421 5L9.70711 1.70711C10.0976 1.31658 10.0976 0.683417 9.70711 0.292893C9.31658 -0.0976311 8.68342 -0.0976311 8.29289 0.292893L5 3.58579L1.70711 0.292893Z" fill="currentColor" fill-opacity="0.65"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'banner-tg-bot',

  props: {
    isVisibile: {
      type: Boolean,
      default: true
    }
  },

  emits: ['close'],
}
</script>

<style scoped>
.banner-tg-bot {
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  width: 100%;
  background: url('@/assets/images/banners/background-tg.png') left center/contain, var( --kaz-support-support-01);
  background-blend-mode: hard-light, normal;
  box-shadow: 4px 0px 16px rgba(74, 74, 74, 0.15);
  border-radius: 8px;
}

.banner-tg-bot__body {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.banner-tg-bot__close-btn {
  display: flex;
  place-items: center;
  width: fit-content;
  aspect-ratio: 1;
  padding: 8px;
  color: #1B1F3B;
  border: none;
  border-radius: 50%;
  background: rgba(242, 242, 242, 0.32);
  backdrop-filter: blur(8px);
}

.banner-tg-bot__close-btn:hover {
  color: var(--kaz-base-primary-hover);
}

.banner-tg-bot__logo {
  width: 52px;
  height: 32px;
  background: url('@/assets/images/banners/background-tg-logo.png') no-repeat;
}

.banner-tg-bot__link {
  --kaz-base-base-09: var(--kaz-textIcons-link);
  color: var(--kaz-textIcons-link);
  text-decoration: none;
}

.banner-tg-bot__link:hover {
  --kaz-base-base-09: var(--kaz-textIcons-link-hover);
  color: var(--kaz-textIcons-link-hover);
}

.banner-tg-bot__link:focus-visible,
.banner-tg-bot__close-btn:focus-visible {
  outline: var(--kaz-base-primary) solid 2px;
  outline-offset: 2px;
}
</style>